/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import NProgress from 'nprogress';
import Backbone from 'backbone';
import _ from 'lodash';

import Scaffold from '@/Scaffold';
import * as NavUtils from '@/util/NavUtils';
import GetExternalUserDetails from '@/services/GetExternalUserDetails';

// import GetExternalUserCommands from '../../external-dashboard/services/GetExternalUserCommands';
import GetExternalUserCommandsPendingApproved from '../../external-dashboard/services/GetExternalUserCommandsPendingApproved';
import ExtProfilePage from '../pages/ExtProfilePage';
import ErrorView from '../../common/views/ErrorView/ErrorView';

export default async function ShowExtProfilePage(customerID) {
  NProgress.start();

  try {
    const [profile, externalUserCommands] = await Promise.all([
      GetExternalUserDetails(),
      GetExternalUserCommandsPendingApproved()
    ]);

    if ((customerID !== profile.id) || !EXTERNAL) {
      showAuthError();
      return;
    }

    Scaffold.getRegion('content').show(
      new ExtProfilePage({
        model: new Backbone.Model({
          profile,
          externalUserCommands
        })
      })
    );

    NavUtils.navigate(`ext/profile/customer/${customerID}`);
  } catch (err) {
    Scaffold.getRegion('content').show(
      new ErrorView({
        model: new Backbone.Model({
          errorMessage: _.isString(err.message) ? err.message : 'An Error Occurred',
          errorDetails: 'Something went wrong while loading the Profile page.'
        })
      })
    );
  } finally {
    NProgress.done();
  }

  function showAuthError() {
    Scaffold.getRegion('content').show(
      new ErrorView({
        model: new Backbone.Model({
          errorMessage: 'Access Denied',
          errorDetails: 'Your account may not have permission to view the Customer\'s Profile page.'
        })
      })
    );
    NProgress.done();
  }
}
